import { Directive, ElementRef, inject, Input, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appTestingId]',
})
export class TestingDirective implements OnChanges {
  private readonly element = inject(ElementRef<any>);

  @Input() appTestingId?: string;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.appTestingId) {
      this.element.nativeElement.setAttribute('data-qa', this.appTestingId);
    }
  }
}
